class UnexpectedTypeError extends Error {
  constructor() {
    super('Unexpected type');
  }
}

export { UnexpectedTypeError };
